import { Skeleton } from '@chakra-ui/react';
import { ContentContainer } from 'app/components/Core';
import { PlaylistHeaderLoader } from 'app/components/Playlist/PlaylistHeaderLoader';
import { useIsMobile } from 'app/utils/hooks';
import { ContentContainerType } from 'types/enums';

export const SharedPlaylistHeaderLoader = () => {
  const isMobile = useIsMobile();

  if (isMobile) {
    return (
      <ContentContainer
        type={ContentContainerType.LIST}
        pt={10}
        flex="initial"
        height={240}
        bg="borderSubdued"
      >
        <Skeleton height="40px" w="full" mb={2} />
        <Skeleton height="20px" w="full" mb={9} />
      </ContentContainer>
    );
  }

  return (
    <PlaylistHeaderLoader
      sx={{
        pt: 10,
      }}
    />
  );
};
